/**
 * http.js
 * 封装axios，
 * 调用方法:
 * http.get('/api/enquiry/web/query',{id:1}).then((res)=>{你的操作})
 * http.post('/api/enquiry/web/update',{id:1}).then((res)=>{你的操作})
 * http.postFormData('/api/enquiry/web/update',{id:1,file:file}).then((res)=>{你的操作})
 */
import axios from 'axios'
import qs from 'qs'
import router from '../router/index'
import Router from "vue-router";
import Cookie from 'vue-cookies'
import login from "../login";
import v1 from "../main";

let urllink = process.env.API_ROOT;
import Vue from 'vue';
let vue_toast = new Vue({})
export default {
  /**
   * get方法，对应get请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  get (url, params) {
    if(!params)
      params = {}
    params.api_token = Cookie.get('app_token');
    let paramsqs = params;
    return new Promise((resolve, reject) => {
      axios.get(urllink+url, {
        params: paramsqs
      }).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  /**
   * post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  post (url, params) {
    if(url != '/api/wap/public/search'){
      vue_toast.$loading('','open')
    }
    if(!params)
      params = {}
    params.api_token = Cookie.get('app_token');
    let paramsqs = qs.stringify(params);
    return new Promise((resolve, reject) => {
      axios.post(urllink+url, paramsqs)
        .then(res => {
          vue_toast.$loading('','close')
          if(res.data.errno == 80005){
            router.push('/bind_phone')
          }else if(res.data.errno == 80001){
            login.login();
          }else{
            resolve(res.data)
          }
        })
        .catch(err => {
          vue_toast.$loading('','close')
          reject(err)
        })
    })
  },
  /**
   * postFormData方法，对应post请求，用来提交文件+数据
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  postFormData (url, params) {
    params.append('api_token',Cookie.get('app_token'));
    //let paramsqs = qs.stringify(params);
    url = urllink + url
    return new Promise((resolve, reject) => {
      axios({
        headers: {
          'Content-Type': 'multipart/form-data'// ;boundary=----WebKitFormBoundaryQ6d2Qh69dv9wad2u
        },
       /* transformRequest: [function (data) { // 在请求之前对data传参进行格式转换
          const formData = new FormData()
          Object.keys(data).forEach(key => {
            formData.append(key, data[key])
          })
          return formData
        }],*/
        url,
        method: 'post',
        data: params
      }).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/request/http.js